var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for user operations.
 */
import { getHeaders, escapeCql } from "./apiUtils";
import { API_PATHS } from "../types/apiPaths";
var USERS_ENDPOINT = "czna-users/users";
var DEFAULT_LIMIT = 30;
/**
 * Builds a CQL query for user search.
 * Searches across lastName, firstName, and email fields with wildcard matching.
 * Optionally filters by user status (ACTIVE/INACTIVE) and organization.
 * `sortBy` may name several keys (organization sorts by sigla, then name); the direction
 * applies to each of them.
 *
 * <p>Roles are not part of it (CZNA-1598): an NK role is a reading of a stored row, not a
 * column CQL can match, so the role filter travels as the `roles` parameter of
 * {@link fetchUsers} and the server ANDs it with this query.
 */
export var buildUserSearchQuery = function (searchTerm, status, sortBy, sortOrder, organizationId) {
    var conditions = [];
    if (searchTerm.trim()) {
        var escaped = escapeCql(searchTerm.trim());
        conditions.push("(lastName==\"*".concat(escaped, "*\" or firstName==\"*").concat(escaped, "*\" or email==\"*").concat(escaped, "*\")"));
    }
    if (status && status !== "ALL") {
        conditions.push("status==\"".concat(status, "\""));
    }
    if (organizationId) {
        conditions.push("organization.id==\"".concat(escapeCql(organizationId), "\""));
    }
    var query = conditions.length === 0 ? "cql.allRecords=1" : conditions.join(" and ");
    var sortKeys = (Array.isArray(sortBy) ? sortBy : [sortBy]).filter(Boolean);
    if (sortKeys.length > 0) {
        var order_1 = sortOrder === "descending" ? "sort.descending" : "sort.ascending";
        query += " sortBy ".concat(sortKeys.map(function (key) { return "".concat(key, "/").concat(order_1); }).join(" "));
    }
    return query;
};
/**
 * `roles`: global roles and NK roles (CZNA-1598); a user matches when it holds any of them.
 * Sent as one comma-separated parameter, only when non-empty.
 *
 * `authorityTypes`: authority type codes from the registry (CZNA-1610). They narrow the NK
 * roles only — an NK role counts when held on one of these types, types without an NK role
 * mean any NK role on them — and leave the global roles alone. Sent the same way.
 */
export var fetchUsers = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var _a, query, _b, offset, _c, limit, _d, roles, _e, authorityTypes, searchParams;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_f) {
            _a = params.query, query = _a === void 0 ? "cql.allRecords=1" : _a, _b = params.offset, offset = _b === void 0 ? 0 : _b, _c = params.limit, limit = _c === void 0 ? DEFAULT_LIMIT : _c, _d = params.roles, roles = _d === void 0 ? [] : _d, _e = params.authorityTypes, authorityTypes = _e === void 0 ? [] : _e;
            searchParams = new URLSearchParams();
            searchParams.set("query", query);
            if (roles.length > 0)
                searchParams.set("roles", roles.join(","));
            if (authorityTypes.length > 0)
                searchParams.set("authorityTypes", authorityTypes.join(","));
            searchParams.set("offset", offset.toString());
            searchParams.set("limit", limit.toString());
            return [2 /*return*/, ky
                    .get("".concat(USERS_ENDPOINT, "?").concat(searchParams), {
                    headers: getHeaders(),
                })
                    .json()];
        });
    });
};
export var fetchCurrentUser = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get(API_PATHS.CZNA_USERS_USERS_ME, { headers: getHeaders() })
                .json()];
    });
}); };
export var updateCurrentUser = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .put(API_PATHS.CZNA_USERS_USERS_ME, { json: data, headers: getHeaders() })
                .json()];
    });
}); };
/**
 * CZNA-1598 review: the user version a role write stands on, as the `userVersion` query
 * parameter — the server refuses the write with 409 OPTIMISTIC_LOCK when the user changed
 * since, before writing anything. Nothing is sent when the caller has no version.
 */
var userVersionParam = function (userVersion) {
    return userVersion !== undefined ? { searchParams: { userVersion: userVersion } } : {};
};
/**
 * Adds a global role to a user.
 */
export var addGlobalRole = function (ky, userId, role, 
/** Only an undo sends one: it puts a removed role back with the window it had. */
validity, userVersion) {
    return ky
        .post("".concat(USERS_ENDPOINT, "/").concat(userId, "/roles"), __assign({ json: __assign({ role: role }, validity), headers: getHeaders() }, userVersionParam(userVersion)))
        .json();
};
/**
 * Removes a global role from a user.
 */
export var removeGlobalRole = function (ky, userId, role, userVersion) {
    return ky
        .delete("".concat(USERS_ENDPOINT, "/").concat(userId, "/roles/").concat(role), __assign({ headers: getHeaders() }, userVersionParam(userVersion)))
        .json();
};
/**
 * Adds an authority type specific role to a user.
 */
export var addAuthorityTypeRole = function (ky, userId, request, userVersion) {
    return ky
        .post("".concat(USERS_ENDPOINT, "/").concat(userId, "/authority-type-roles"), __assign({ json: request, headers: getHeaders() }, userVersionParam(userVersion)))
        .json();
};
/**
 * Updates an authority type specific role for a user.
 */
export var updateAuthorityTypeRole = function (ky, userId, roleId, request, userVersion) {
    return ky
        .put("".concat(USERS_ENDPOINT, "/").concat(userId, "/authority-type-roles/").concat(roleId), __assign({ json: request, headers: getHeaders() }, userVersionParam(userVersion)))
        .json();
};
/**
 * Removes an authority type specific role from a user.
 */
export var removeAuthorityTypeRole = function (ky, userId, roleId, userVersion) {
    return ky
        .delete("".concat(USERS_ENDPOINT, "/").concat(userId, "/authority-type-roles/").concat(roleId), __assign({ headers: getHeaders() }, userVersionParam(userVersion)))
        .json();
};
